export default {"src":"/_next/static/media/photo.f00bce54.svg","height":26,"width":27};